/// <reference path="../../../teva/selectbox/selectbox.ts" />

namespace OfficeGuy.Apps {
    export class EmailNotifications {
        static InitEditor() {
            $(".og-emailnotifications-schema .schemapicker").on("change", function () {
                OfficeGuy.Apps.EmailNotifications.SchemaChanged($(this).val());
            });
            $(".og-emailnotifications-filtersview .viewpicker").on("change", function () {
                OfficeGuy.Apps.EmailNotifications.ViewChanged();
            });
        }

        static SchemaChanged(SchemaID): void {
            var SchemaID = SchemaID;
            var Schema = Teva.SelectBox.GetInstance($(".og-emailnotifications-schema .schemapicker"));
            Teva.SelectBox.GetInstance($(".og-emailnotifications-filtersview .schemapicker")).SetValue(Schema.SelectedValue, Schema.SelectedText)
            Teva.SelectBox.GetInstance($(".og-emailnotifications-property .schemapicker")).SetValue(Schema.SelectedValue, Schema.SelectedText);
            Teva.SelectBox.GetInstance($(".og-emailnotifications-emailfield .schemapicker")).SetValue(Schema.SelectedValue, Schema.SelectedText);
        }

        static ViewChanged(): void {
            var View = Teva.SelectBox.GetInstance($(".og-emailnotifications-filtersview .viewpicker"));
            Teva.SelectBox.GetInstance($(".og-emailnotifications-emailfield .viewpicker")).SetValue(View.SelectedValue, View.SelectedText);
        }
    }
}
